/* import __COLOCATED_TEMPLATE__ from './invoice-billing-period-total.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();